import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FiCalendar, FiMapPin, FiArrowRight, FiCheckCircle, FiXCircle } from "react-icons/fi";
import "../pages/events.css";

const Posters = ({ imagepath, headertext, venue, date, button, vendors, index = 0 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.transitionDelay = `${index * 0.1}s`;
          el.classList.add("poster-visible");
          obs.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [index]);

  const isVendorOpen = vendors.toLowerCase().includes("open");

  return (
    <article className="poster-card" ref={ref}>
      {/* Poster Image Panel */}
      <div className="poster-img-panel">
        <img 
          src={imagepath} 
          alt={headertext} 
          className="poster-img"
          loading="lazy"
          onError={(e) => {
            e.target.src = "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?auto=format&fit=crop&w=800&q=80";
          }}
        />
        <div className="poster-img-overlay" />
      </div>

      {/* Content Body */}
      <div className="poster-content">
        <div className="poster-header">
          <div className="poster-tag-row">
            <span className="poster-category-tag">FESTIVAL</span>
            <span className={`poster-vendor-badge ${isVendorOpen ? "v-open" : "v-closed"}`}>
              {isVendorOpen ? <FiCheckCircle /> : <FiXCircle />}
              {isVendorOpen ? "Vendors Open" : "Vendors Closed"}
            </span>
          </div>
          <h2 className="poster-title">{headertext}</h2>
        </div>

        {/* Streamlined Meta Info */}
        <div className="poster-meta-strip">
          <div className="meta-chip">
            <FiCalendar className="chip-icon" />
            <span>{date}</span>
          </div>

          <div className="meta-chip">
            <FiMapPin className="chip-icon" />
            <span>{venue}</span>
          </div>
        </div>

        {/* Footer CTA Action */}
        <div className="poster-footer">
          <Link to={button} className="poster-btn">
            <span>EXPLORE EVENT</span>
            <FiArrowRight className="poster-btn-arrow" />
          </Link>
        </div>
      </div>
    </article>
  );
};

Posters.propTypes = {
  imagepath: PropTypes.string.isRequired,
  headertext: PropTypes.string.isRequired,
  venue: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  vendors: PropTypes.string.isRequired,
  index: PropTypes.number,
};

export default Posters;